export default "__VITE_ASSET__B0w52Aom__"